import axiosInstance from 'api/axiosInstance'
import { type ActivitySettings } from 'types/api/settings'

export const setActivity = async (settings: ActivitySettings) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/media/settings/media',
        data: {
            ...(settings.showLikeHistory !== undefined && {
                show_liked_history: settings.showLikeHistory
            }),
            ...(settings.showWatchedHistory !== undefined && {
                show_watched_history: settings.showWatchedHistory
            })
        }
    })
    return data
}
